/** IANA time zone of the browser (e.g. "Australia/Sydney"), or undefined when the runtime cannot report one.
 *  Sent as roasterTimeZone so the backend resolves "today" on the same clock as the date picker.
 *  Never throws: a detection failure must not block a submission, the backend falls back to the UTC date. */
export const getBrowserTimeZone = (): string | undefined => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
};
